<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col v-for="(item,index) in mockData" :key="index" :span="12">
            <a-form-item :label="item.mockName" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="item.mockValue"  :placeholder="'请输入'+item.mockName"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="12" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'SysBigdataEditDataForm',
    components: {
      JFormContainer,
      JDictSelectTag,
    },
   
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 12 },
          sm: { span: 12 },
        },
        wrapperCol: {
          xs: { span: 12 },
          sm: { span: 12 },
        },
        confirmLoading: false,

        url: {
          sublist: "/sys/sysapimockvalue/list",
          addlist: "/sys/sysapimockvalue/addlist"
        },
        mockData:[]
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {

    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        let that = this;
        this.visible = true;
        httpAction(this.url.sublist+"?mockId="+record.id,null,'get').then((res)=>{
          if(res.success){
            this.mockData = res.result;
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })

      },

      submitForm () {
        const that = this;
        let formData = that.mockData;
        for (let i = 0; i < formData.length; i++) {
          if(formData[i].mockValue==null||formData[i].mockValue==undefined||formData[i].mockValue==""){
            that.$message.warning("请输入"+formData[i].mockName);
            return false;
          }
          
        }
        httpAction(that.url.addlist,formData,'post').then((res)=>{
        if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },

    }
  }
</script>

<style scoped>
  .ant-form-item{
    margin-bottom: 0px !important;
  }

</style>